export const wrhLangId = {
         ticketWrh: {
           storeName: "nama merchant/toko",
           selectStore: "silahkan pilih nama merchant/toko",
           waitApproval: "menunggu persetujuan",
           alApproval: "telah disetujui",
           appliedPanel: "Sudah mengajukan",
           look: "memeriksa",
           approvalComments: "komentar persetujuan terkait",
           currentApproval: "Penyetuju saat ini",
           time: "waktu",
           approvalPeople: "yang menyetujui",
           approvalComment: "komentar persetujuan ",
           waitOrder: "menunggu ditangani",
           orderstatus: "status ticket",
           loanamount: "jumlah pencairan",
           partiallyCompleted: "pembayaran sebagian",
           normalStatus: "normal",
           noNormalStatus: "tidak normal",
           userName: "nama pengguna",
           orderInvalidTime: "waktu invalid ticket",
           dial: "penelponan",
           Submit: "submit",
           IsGP0: "non-F2F",
           IsGP1: "F2F",
           showNumber: "ekstensi",
         },
         tipsWrh: {
           calcFee: "menghitung biaya layanan",
           calcFeeTip:
             "perhatian:masukan jumlah pembayaran,setelah klik biaya layanan maka biaya layanan dan IVA biaya layanan akan tampil",
           fee: "biaya pengurusan",
           feeIVA: "biaya IVA",
           currentPersonalTime: "Jumlah sisa potongan perorangan",
           currentGroupTime: "Jumlah sisa potongan tim saat ini",
           currentRemainingDeduction: "Sisa Potongan Bisa Diajukan Saat Ini",
           makeLoan: "Pencairan放款",
           continueFollow: "lanjutkan penanganan",
           userBirthday: "tanggal lahir pengguna",
           enterUserBirthday: "silahkan isi tanggal lahir user",
           opreSuccess: "pengoperasian berhasil",
           enterMark: "lainnya:(silahkan isi komentar)",
           userAndOrder: "informasi ticket dan user",
           diaOperation: "pengoperasian telepon",
           productInfo: "informasi produk",
           product: "produk",
           pleaseResult: "silahkan pilih hasil",
           previewImage: "saya adalah gambar,klik untuk melihatnya",
           selectBrithday: "silahkan pilih tanggal lahir",
           enterTelephone: "silahkan masukan nomor handpone",
           enterIdCard: "silahkan masukan ID ktp",
           enterCurp: "silahkan masukan nomor CURP",
           enterStaffNum: "silahkan masukan nomor id staff",
           enterChilNum: "silahkan masukkan jumlah anak dalam keluarga",
           enterFamilyAddress: "silahkan masukkan alamat rumah",
           enterPhone: "silahkan masukkan nomor hp",
           enterCompanyName: "silahkan masukkan nama perusahaan",
           enterCompanyPosition: "silahkan masukkan posisi perusahaan",
           enterCompanyTime: "silahkan masukkan waktu kerja",
           enterRewardMoney: "silahkan masukkan nominal",
           editPeople: "edit informasi staff",
           addPeople: "tambah informasi staff",
           enterRFC: "silahkan masukkan RFC",
           noNormal: "tidak formal",
           admin: "AdminAdmin",
           editBaseInfo: "edit informasi pribadi",
           enterStatus: "silahkan pilih status saat ini",
           recordTitle: "Catatan mulai kerja dan pengunduran diri",
           clickAdd: "klik tambahkan informasi dasar staff",
           workRecord: "Catatan mulai kerja dan pengunduran diri",
           enterChooseTime: "Silahkan pilih waktu",
           tip: "Petunjuk提示",
           cumulativeReward: "Hadiah akumulatif",
           cumulativePunish: "Sanksi akumulatif",
           cumulativeLtter: "menerima surat peringatan",
           Times: "kali",
           seal: "tutup",
         },
         menuWrh: {
           reduceApproval: "Persetujuan Potongan",
           teleMarket: "Telemarketing",
           teleMarketRecord: "Catatan Telemarketing",
         },
         tableWrh: {
           reduceType: "Jenis potongan",
           applyPeople: "pemohon",
           approvalResult: "hasil persetujuan",
           reduceResult: "Hasil Potongan",
           approvalDetail: "Rincian persetujuan",
           reduceAmount: "nominal potongan",
           Operador: "staff telemarketing",
           dialTime: "waktu penelponan",
           whentherDial: "apakah terhubung?",
           dialSituation: "situasi terhubung/tidak terhubung",
           remark: "catatan",
         },
         formWrh: {
           birthDay: "tanggal lahir",
           cardId: "nomor KTP",
           cardCURP: "Nomor CURP",
           cardPhoto: "foto KTP",
           staffNum: "staff ID",
           marryStatus: "status pernikahan",
           chilNum: "Jumlah anak dalam keluarga",
           familyAddress: "alamat rumah",
           addressProof: "bukti alamat tempat tinggal",
           familyContact: "Kontak yang bisa dihubungi",
           familyRealtion: "hubungan",
           familyTelephone: "Nomor hp",
           companyName: "Nama Perusahaan",
           companyPosition: "posisi dalam perusahaan",
           companyTime: "waktu mulai bekerja",
           punishType: "Kategori hadiah dan sanksi",
           punishMoney: "Nominal",
           questionType: "Jenis hukuman",
           Type: "Jenis",
           punishDesc: "Deskripsi",
           //选择项label
           man: "Laki-laki",
           woman: "Perempuan",
           onJob: "sedang bekerja",
           quit: "resign",
           married: "sudah menikah",
           unmarried: "belum menikah",
           single: "Lajang",
           cohabitation: "Kohabitasi",
           parent: "orang tua",
           couple: "suami istri",
           children: "anak perempuan",
           friend: "teman",
           reward: "Hadiah Kumulatif",
           punish: "hukuman",
           complianceIssues: "masalah kepatuhan",
           businessIssues: "masalah bisnis",
           disciplinaryIssues: "masalah kedisiplinan",
           oralWarning: "Verbal warning",
           commitLetter: "surat perjanjian",
           warningLetter: "surat peringatan",
           RFC: "RFC",
           personalInfo: "Info personal",
           identityInfo: "Informasi pribadi",
           familyInfo: "Latar belakang keluarga",
           workInfo: "Informasi pekerjaan",
           occupancyInfo: "pengalaman kerja",
           rewardInfo: "catatan hukuman dan hadiah",
           staffStatusInfo: "status karyawan",
           upload: "unggah",
           status: "status",
           leaveTime: "waktu pengunduran diri",
           enterTime: "waktu mulai kerja",
           leaveReason: "alasan pengunduran diri",
         },
       };
